import { useState } from 'react'
import { Button, Modal } from 'antd'
import styles from './LoginPage.module.css'
import userManager from '../../oidcConfig'
import formaLogo from '../../assets/images/formalogosvg.svg'

import { WindowsOutlined } from '@ant-design/icons'

const LoginPage = () => {
  const [isAccessibilityModalOpen, setAccessibilityModalOpen] = useState(false)

  const onLogin = () => {
    userManager.signinRedirect() // Redirige l'utilisateur vers le fournisseur OIDC pour la connexion
  }

  return (
    <div className={styles.container}>
      <div className={styles.imageContainer}></div>
      <div className={styles.container__block}>
        <div className={styles.block__login}>
          <div className={styles.login__content}>
            <div className={styles.title__container}>
              <img
                src={formaLogo}
                alt="Forma Logo"
                className={styles.logo__forma}
              />
              <div className={styles.title__container__text}>
                <div className={styles.title}>Bienvenue sur FORMA</div>
                <div className={styles.description}>
                  Cliquez sur le bouton ci-dessous pour vous connecter.
                </div>
              </div>
            </div>

            <div className={styles.sso__container}>
              <button
                onClick={onLogin}
                className={styles.boutton__OIDC_test}
                type="button"
                aria-label="Connexion SSO - Connexion automatique"
              >
                <WindowsOutlined className={styles.logo__windows} />
                Connexion automatique
              </button>
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <div>Forma v1.0</div>
          <div>
            <span
              className={styles.linkCustomStyle}
              style={{ cursor: 'pointer' }}
              onClick={() => setAccessibilityModalOpen(true)}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault()
                  setAccessibilityModalOpen(true)
                }
              }}
              tabIndex={0}
              role="button"
              aria-label="Déclaration d'accessibilité"
            >
              Accessibilité non-conforme
            </span>
          </div>
        </div>
      </div>
      <Modal
        title="Accessibilité non-conforme"
        open={isAccessibilityModalOpen}
        onCancel={() => setAccessibilityModalOpen(false)}
        footer={[
          <Button
            key="close"
            onClick={() => setAccessibilityModalOpen(false)}
            className={styles.button_close_modal}
          >
            <span>Fermer</span>
          </Button>,
        ]}
        width={700}
        bodyStyle={{ maxHeight: '70vh', overflowY: 'auto' }}
        destroyOnClose
      >
        {/* Accessibility Declaration Content styled for DA consistency */}
        <div className={styles.accessibilityModalContent}>
          <p>
            <strong>DÉCLARATION D'ACCESSIBILITÉ</strong>
            <br />
            <br />
            Montpellier Méditerranée Métropole s'engage à rendre ses sites
            internet, intranet, extranet et ses applications mobiles accessibles
            conformément à l'article 47 de la loi n° 2005-102 du 11 février
            2005.
            <br />
            <br />À cette fin, elle met en œuvre la stratégie et les actions
            décrites dans le schéma pluriannuel et les plans d'action :&nbsp;
            <a
              href="https://www.montpellier.fr/schema-amelioration-accessibilite"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.montpellier.fr/schema-amelioration-accessibilite
            </a>
            <br />
            <br />
            Cette déclaration d'accessibilité s'applique à Forma.
            <br />
            <br />
            <strong>ÉTAT DE CONFORMITÉ</strong>
            <br />
            « NON ÉVALUÉ = NON-CONFORME »<br />
            L'audit de conformité n'ayant pas encore été réalisé, il est
            considéré que Forma ne respecte pas les règles du Référentiel
            Général d'Amélioration de l'Accessibilité Numérique (RGAA).
            <br />
            De ce fait, tout le contenu est considéré non accessible.
            <br />
            <br />
            <strong>ÉTABLISSEMENT DE CETTE DÉCLARATION D'ACCESSIBILITÉ</strong>
            <br />
            Cette déclaration a été établie le 23 Juin 2025.
            <br />
            Elle sera mise à jour dès que des tests de conformité seront
            réalisés.
            <br />
            <br />
            <strong>RETOUR D'INFORMATION ET CONTACT</strong>
            <br />
            <br />
            <u>Contact</u>
            <br />
            Si vous n'arrivez pas à accéder à un contenu ou à un service, vous
            pouvez contacter le responsable du service pour être orienté vers
            une alternative accessible ou obtenir le contenu sous une autre
            forme :<br />- Formulaire en ligne :&nbsp;
            <a
              href="https://cds-informatique.montpellier3m.fr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://cds-informatique.montpellier3m.fr
            </a>
            <br />- Référent Numérique Responsable :&nbsp;
            <a href="mailto:PND.NR@montpellier.fr">PND.NR@montpellier.fr</a>
            <br />
            <br />
            <u>Voies de recours</u>
            <br />
            Cette procédure est à utiliser dans le cas suivant : vous avez
            signalé un défaut d'accessibilité qui vous empêche d'accéder à un
            contenu ou à un des services du portail et vous n'avez pas obtenu de
            réponse satisfaisante.
            <br />- Écrire au Défenseur des droits :&nbsp;
            <a
              href="https://formulaire.defenseurdesdroits.fr/"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://formulaire.defenseurdesdroits.fr
            </a>
            <br />- Contacter le délégué régional du Défenseur des droits
            :&nbsp;
            <a
              href="https://www.defenseurdesdroits.fr/saisir/delegues"
              target="_blank"
              rel="noopener noreferrer"
            >
              https://www.defenseurdesdroits.fr/saisir/delegues
            </a>
            <br />
            - Par courrier (gratuit, sans affranchissement) :<br />
            Défenseur des droits
            <br />
            Libre réponse 71120
            <br />
            75342 Paris CEDEX 07
          </p>
        </div>
      </Modal>
    </div>
  )
}

export default LoginPage
